import { configureStore } from '@reduxjs/toolkit';
import windowObserver from '@utils/WindowObserver/window-observer.slice';
import cookies from '@utils/Cookies/cookies.slice';
import maplibremap from '@library/MaplibreMap/maplibre-map.slice';
import guidedTour from '@library/GuidedTour/guided-tour.slice';
import navbarMobileMenu from '@App/components/Navbar/NavbarMobileMenu/navbar-mobile-menu.slice';

const createStoreArgs = [];

if (import.meta.env.DEV) {
  const { createLogger } = await import('redux-logger');
  const logger = createLogger({
    collapsed: (_getState, _action, logEntry) => !logEntry.error,
  });

  createStoreArgs.push(logger);
}

const store = configureStore({ 
  reducer: {
    windowObserver,
    cookies,
    maplibremap,
    guidedTour,
    navbarMobileMenu,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(createStoreArgs),
});

export default store
